var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'nuxt-property-decorator';
import { STATES } from '~/classes/App';
import AbstractPage from '~/mixins/AbstractPage';
import { API_PATHS, PATHS } from '~/router';
import FormRegistrationStep1 from '~/components/forms/auth/registration/step1.vue';
import FormRegistrationStep2 from '~/components/forms/auth/registration/step2.vue';
import IconLoading from '~/components/icons/Loading.vue';
let Registration = class Registration extends AbstractPage {
    constructor() {
        super(...arguments);
        this.PATHS = PATHS;
        this.STATES = STATES;
        this.STEPS_COUNT = 3;
        this.error = {
            message: ''
        };
        this.state = STATES.SUCCESS;
        this.step = 1;
        this.registrationData = {};
        this.isIdAustriaRegistration = false;
        this.step1FormAction = API_PATHS.AUTH.REGISTER.STEP1;
        this.step2FormAction = API_PATHS.AUTH.REGISTER.STEP2;
        this.token = '';
    }
    get infoPoints() {
        const points = [];
        for (let i = 1; i <= 5; i++) {
            if (this.portal.key === 'bpk' && i === 3) {
                continue;
            }
            points.push(this.$te(`${this.portal.key}.info.text${i}`) ? this.$t(`${this.portal.key}.info.text${i}`) : this.$t(`info.text${i}`));
        }
        return points;
    }
    created() {
        if (this.$route.query.token) {
            this.state = STATES.LOADING;
            this.$axios
                .get(API_PATHS.AUTH.REGISTER.PARSE_TOKEN.replace('{token}', this.$route.query.token.toString()))
                .then((response) => {
                this.registrationData = response.data;
                this.state = STATES.SUCCESS;
            }).catch((error) => {
                var _a;
                this.state = STATES.ERROR;
                if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message) {
                    this.error.message = error.response.data.message;
                }
            });
        }
        if (this.$route.query.step1) {
            const queryParams = JSON.parse(atob(decodeURIComponent(this.$route.query.step1)));
            Object.keys(queryParams).forEach((key, index) => {
                this.step1FormAction += `${index === 0 ? '?' : '&'}${key}=${encodeURIComponent(queryParams[key])}`;
            });
        }
        if (this.$route.query.step2) {
            const queryParams = JSON.parse(atob(decodeURIComponent(this.$route.query.step2)));
            Object.keys(queryParams).forEach((key, index) => {
                this.step2FormAction += `${index === 0 ? '?' : '&'}${key}=${encodeURIComponent(queryParams[key])}`;
            });
        }
        this.isIdAustriaRegistration = this.$route.query.idAustria === '1';
    }
    handleIdAustriaLogin() {
        this.$axios.get(API_PATHS.ID_AUSTRIA.LOGIN).then((response) => {
            var _a, _b;
            if ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.url) === null || _b === void 0 ? void 0 : _b.redirect) {
                window.location.href = response.data.url.redirect;
            }
            else {
                this.$nuxt.error({ statusCode: 500, message: 'Fehler beim Anmelden mit ID Austria' });
            }
        });
    }
    onSuccessRegistrationStep1(_response, formData) {
        this.registrationData = formData.registration;
        this.step = 2;
    }
    onSuccessRegistrationStep2(_response, formData) {
        this.registrationData = formData.registration;
        this.step = 3;
    }
    resetError() {
        this.error = {
            message: ''
        };
    }
};
Registration = __decorate([
    Component({
        components: {
            FormRegistrationStep1,
            FormRegistrationStep2,
            IconLoading
        },
        middleware: [
            'auth/redirect/authentificated'
        ]
    })
], Registration);
export default Registration;
